import { Quill } from 'react-quill';

const FontFamily = Quill.import('formats/font');
FontFamily.whitelist = ['Arial', 'Roboto', 'Raleway', 'Montserrat', 'Lato', 'Rubik'];

export { FontFamily };
